module.exports = __webpack_public_path__ + "static/media/fitness-dashboard.f7f5204a.png";